import { Button, Group, Select, Text } from "@mantine/core";
import { DateInput } from "@mantine/dates";
import {
  STATUS_OPTIONS,
  TRIP_SIMPLIFIED_STATUS_OPTIONS,
  TYPE_OPTIONS,
} from "../../utils/allPolicyConstants";
import classes from "../../pages/Trips/Trips.module.css";

const H = 44;

const hideDateClearStyles = { section: { display: "none" } };

const AllPolicyToolbar = ({
  statusFilter,
  onStatusChange,
  tripStatusFilter,
  onTripStatusChange,
  typeFilter,
  onTypeChange,
  dateRange,
  onDateRangeChange,
  onClearDates,
  resultCount,
  onExport,
  isMobile = false,
}) => {
  const toolbarLeftContent = (
    <Group
      gap="xs"
      wrap={isMobile ? "wrap" : "nowrap"}
      align="center"
      className={classes.toolbarMain}
    >
      <Select
        data={STATUS_OPTIONS}
        value={statusFilter}
        onChange={(value) => onStatusChange(value || "")}
        className={classes.filterSelect}
        h={H}
        allowDeselect={false}
      />
      <Select
        placeholder="All Trip Status"
        data={TRIP_SIMPLIFIED_STATUS_OPTIONS}
        value={tripStatusFilter || null}
        onChange={(value) => onTripStatusChange(value ?? "")}
        className={classes.filterSelectWide}
        h={H}
        clearable
        searchable={false}
      />
      <Select
        data={TYPE_OPTIONS}
        value={typeFilter}
        onChange={(value) => onTypeChange(value || "")}
        className={classes.filterSelect}
        h={H}
        allowDeselect={false}
      />
      <Group
        gap={6}
        wrap={isMobile ? "wrap" : "nowrap"}
        align="center"
        className={classes.dateFilterGroup}
      >
        <Text size="sm" fw={600}>Updated:</Text>
        <DateInput
          value={dateRange[0]}
          onChange={(value) => onDateRangeChange([value, dateRange[1]])}
          placeholder="mm/dd/yyyy"
          valueFormat="MM/DD/YYYY"
          w={isMobile ? "100%" : 108}
          h={H}
          clearable={false}
          className={classes.dateFilterInput}
          styles={hideDateClearStyles}
        />
        <Text c="dimmed" size="sm">→</Text>
        <DateInput
          value={dateRange[1]}
          onChange={(value) => onDateRangeChange([dateRange[0], value])}
          placeholder="mm/dd/yyyy"
          valueFormat="MM/DD/YYYY"
          w={isMobile ? "100%" : 108}
          h={H}
          clearable={false}
          className={classes.dateFilterInput}
          styles={hideDateClearStyles}
        />
        {(dateRange[0] || dateRange[1]) ? (
          <Button
            variant="subtle"
            color="gray"
            size="compact-sm"
            className={classes.clearDatesBtn}
            onClick={onClearDates}
          >
            Clear
          </Button>
        ) : null}
      </Group>
    </Group>
  );

  const toolbarBottomContent = (
    <Group
      gap="sm"
      wrap={isMobile ? "wrap" : "nowrap"}
      className={classes.toolbarActions}
    >
      <Text size="sm" fw={600} c="dimmed" className={classes.resultCount}>
        {resultCount.toLocaleString("en-IN")} results
      </Text>
      <Button
        variant="filled"
        color="#033F7C"
        className={classes.exportBtn}
        onClick={onExport}
      >
        Export
      </Button>
    </Group>
  );

  return { toolbarLeftContent, toolbarRightContent: null, toolbarBottomContent };
};

export default AllPolicyToolbar;
